import {
  generateInvoiceApiRequest,
  getInvoiceApiRequest,
  getInvoiceByOrderApiRequest,
  getInvoiceDownloadUrlApiCall,
  getInvoiceTemplateApiRequest,
  getMyInvoicesApiCall,
  getProviderInvoicesApiRequest,
  resendInvoiceApiRequest,
  sendTestInvoiceApiRequest,
  updateInvoiceApiRequest,
  upsertInvoiceTemplateApiRequest,
} from '@guryou/api-client-gql';

import { execute } from '../actions/actionWrapper';
import { Action, basicReducer } from '../core';

// Provider (deal) invoice management
export const GET_INVOICE_TEMPLATE = { entity: 'GET_INVOICE_TEMPLATE', action: Action.GET_ONE };
export const UPSERT_INVOICE_TEMPLATE = { entity: 'UPSERT_INVOICE_TEMPLATE', action: Action.UPDATE };
export const GET_PROVIDER_INVOICES = { entity: 'GET_PROVIDER_INVOICES', action: Action.GET_MANY };
export const RESEND_INVOICE = { entity: 'RESEND_INVOICE', action: Action.UPDATE };
export const GENERATE_INVOICE = { entity: 'GENERATE_INVOICE', action: Action.UPDATE };
export const GET_INVOICE_BY_ORDER = { entity: 'GET_INVOICE_BY_ORDER', action: Action.GET_ONE };
export const SEND_TEST_INVOICE = { entity: 'SEND_TEST_INVOICE', action: Action.UPDATE };
export const UPDATE_INVOICE = { entity: 'UPDATE_INVOICE', action: Action.UPDATE };
export const GET_INVOICE = { entity: 'GET_INVOICE', action: Action.GET_ONE };

export const getInvoiceTemplate = () => async dispatch => execute(dispatch, () => getInvoiceTemplateApiRequest(), GET_INVOICE_TEMPLATE, false);

export const upsertInvoiceTemplate = input => async dispatch =>
  execute(dispatch, () => upsertInvoiceTemplateApiRequest({ input }), UPSERT_INVOICE_TEMPLATE, true);

export const getProviderInvoices = (from, to, customerId) => async dispatch =>
  execute(dispatch, () => getProviderInvoicesApiRequest({ from, to, customerId }), GET_PROVIDER_INVOICES, false);

export const resendInvoice = invoiceId => async dispatch => execute(dispatch, () => resendInvoiceApiRequest({ invoiceId }), RESEND_INVOICE, true);

export const generateInvoice = orderId => async dispatch => execute(dispatch, () => generateInvoiceApiRequest({ orderId }), GENERATE_INVOICE, true);

export const getInvoiceByOrder = orderId => async dispatch =>
  execute(dispatch, () => getInvoiceByOrderApiRequest({ orderId }), GET_INVOICE_BY_ORDER, false);

export const sendTestInvoice = () => async dispatch => execute(dispatch, () => sendTestInvoiceApiRequest(), SEND_TEST_INVOICE, true);

export const getInvoice = id => async dispatch => execute(dispatch, () => getInvoiceApiRequest({ id }), GET_INVOICE, false);

export const updateInvoice =
  (invoiceId, { number, lines } = {}) =>
  async dispatch =>
    execute(
      dispatch,
      () => updateInvoiceApiRequest({ invoiceId, number, linesJson: lines ? JSON.stringify(lines) : undefined }),
      UPDATE_INVOICE,
      true
    );

export const invoiceReducers = {
  template: basicReducer(GET_INVOICE_TEMPLATE),
  upsertTemplate: basicReducer(UPSERT_INVOICE_TEMPLATE),
  list: basicReducer(GET_PROVIDER_INVOICES),
  resend: basicReducer(RESEND_INVOICE),
  generate: basicReducer(GENERATE_INVOICE),
  byOrder: basicReducer(GET_INVOICE_BY_ORDER),
  sendTest: basicReducer(SEND_TEST_INVOICE),
  update: basicReducer(UPDATE_INVOICE),
  single: basicReducer(GET_INVOICE),
};

// Customer (feel) invoices
export const MY_INVOICES_GET = { entity: 'MY_INVOICES', action: Action.GET_MANY };
export const INVOICE_DOWNLOAD_URL_GET = { entity: 'INVOICE_DOWNLOAD_URL', action: Action.GET };

export const getMyInvoices = () => async dispatch => execute(dispatch, () => getMyInvoicesApiCall(), MY_INVOICES_GET, false);
export const downloadMyInvoice = id => async dispatch =>
  execute(dispatch, () => getInvoiceDownloadUrlApiCall({ id }), INVOICE_DOWNLOAD_URL_GET, false);

export const invoiceFeelReducers = {
  list: basicReducer(MY_INVOICES_GET),
  downloadUrl: basicReducer(INVOICE_DOWNLOAD_URL_GET),
};
